import { MutableRefObject, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FunctionComponent<PropsWithChildren<Record<string, unknown>>> = ({ children, elementRef }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const ref = elementRef as MutableRefObject<HTMLElement>;
    if (ref && ref !== undefined && ref.current) {
      ref.current.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }, [pathname]);

  return <>{children}</>;
};

export default ScrollToTop;
